// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/Users/patriciolavagnino/Downloads/Ona-Pulse/mobile/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/alertas.tsx": { enumerable: true, get() { return require("/Users/patriciolavagnino/Downloads/Ona-Pulse/mobile/app/(tabs)/alertas.tsx"); } },
  "./(tabs)/hoteles.tsx": { enumerable: true, get() { return require("/Users/patriciolavagnino/Downloads/Ona-Pulse/mobile/app/(tabs)/hoteles.tsx"); } },
  "./(tabs)/ia.tsx": { enumerable: true, get() { return require("/Users/patriciolavagnino/Downloads/Ona-Pulse/mobile/app/(tabs)/ia.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/Users/patriciolavagnino/Downloads/Ona-Pulse/mobile/app/(tabs)/index.tsx"); } },
  "./+not-found.tsx": { enumerable: true, get() { return require("/Users/patriciolavagnino/Downloads/Ona-Pulse/mobile/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/Users/patriciolavagnino/Downloads/Ona-Pulse/mobile/app/_layout.tsx"); } },
  "./auth.tsx": { enumerable: true, get() { return require("/Users/patriciolavagnino/Downloads/Ona-Pulse/mobile/app/auth.tsx"); } },
  "./descargar.tsx": { enumerable: true, get() { return require("/Users/patriciolavagnino/Downloads/Ona-Pulse/mobile/app/descargar.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;